export const UNASSIGNED_OWNER_ID = 'unassigned'
export const DEFAULT_GUID_VALUE = '00000000-0000-0000-0000-000000000000'

/**
 * Start of the 400 `Message` the server returns when a rule change would strip
 * auto-review coverage from a lead type. Must match the server's
 * `AutomatedAssignmentService.CoverageErrorPrefix`; the lead type enum names
 * follow it, joined with ", ".
 */
export const COVERAGE_ERROR_PREFIX =
  'Auto-review coverage required for lead type(s): '

/** Title of the modal shown when deleting or disabling a rule is blocked. */
export const DELETE_DISABLE_COVERAGE_TITLE =
  'Cannot delete or disable this assignment rule'

/** Title of the modal shown when removing a rule's Type is blocked. */
export const EDIT_COVERAGE_TITLE = 'Cannot remove Type on this assignment rule'

/** Body of the delete/disable modal; `list` is comma-separated display labels. */
export const getDeleteDisableCoverageBody = (list: string) =>
  `This rule allows pending leads of type(s) ${list} to be auto-reviewed. You must update your pending lead settings or create a new assignment rule for the applicable lead type(s) before this rule can be deleted or disabled.`

/** Body of the edit modal; `list` is comma-separated display labels. */
export const getEditCoverageBody = (list: string) =>
  `This rule allows pending leads of type(s) ${list} to be auto-reviewed. You must leave this assignment as is, update your pending lead settings, or create a new assignment rule for the applicable lead type(s) before this rule can be edited.`
